export const tr = {
    'age-required': 'Yaş belirtilmedi',
    'all-conditions-done': 'Tüm koşullar yerine getirildi',
    'all-devices-rate-value': 'Tüm cihazlara %{value} düzenleme belirtilemez',
    'all-inventories-rate-value': 'Tüm envantar türlerinde %{value} düzenleme belirtilemez',
    cloudiness: 'Bulutlanma',
    'cloudiness-clear': 'Bulutsuz\r',
    'cloudiness-hint': 'Bulutlanma: {value}',
    'cloudiness-medium': 'Parçalı bulutlu',
    'cloudiness-overcast': 'Yoğun bulutlu',
    'cloudiness-partly': 'Az bulutlu\r',
    'cloudiness-significant': 'Çok bulutlu\r',
    'equal-items': '{numbers} numaralı koşullar kesişmektedir. Bunlardan birini silin veya ayarları değiştirin.',
    'gender-required': 'Cinsiyet belirtilmedi',
    'incorrect-max-temperature': 'Maksimum sıcaklık en düşük sıcaklığın altında olamaz',
    'intersection-items-warning': {
        one: '{list} koşuluna aykırı',
        some: '{list} koşullarına aykırı',
        many: '{list} koşullarına aykırı',
        none: ''
    },
    'max-rate-value': 'Fiyat teklifi en fazla %{value} artırılabilir',
    'min-rate-value': 'Fiyat teklifi en fazla %{value} düşürülebilir\r',
    'one-condition-done': 'En az biri uygulandı',
    'positive-value': 'Teklif tam pozitif sayı olmalıdır',
    rainfall: 'Yağış',
    'rainfall-average': 'Orta',
    'rainfall-heavy': 'Yoğun\r',
    'rainfall-hint': 'Yağış: {value}',
    'rainfall-light': 'Hafif',
    'rainfall-none': 'Yok',
    'rainfall-rain-snow': 'Sağanak yağmur/kar yağışı',
    'single-mass-rate-empty': 'Ortak teklif belirtilmedi',
    temperature: 'Sıcaklık',
    'temperature-hint': 'Sıcaklık: {minTemperature} - {maxTemperature} °C',
    'traffic-jam-free': 'Yol açık',
    'traffic-jam-hard': 'Trafik yoğun',
    'traffic-jam-light': 'Trafik akıcı',
    'traffic-jam-very-hard': 'Trafik çok yoğun',
    'value-required': 'Teklif belirtilmedi'
};
